import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/react/outline'
import classNames from 'classnames'
import { FieldArray } from 'formik'
import React from 'react'

import FormikInput from '../../shared/components/formik/Input'

export type ArrayListProps = {
  label?: string
  name: string
  inputClassName?: string
  plusButtonClassName?: string
  minusButtonClassName?: string
}

const buttonClassName =
  ' text-gray-light rounded-full stroke-[2rem] w-[27px] mt-6 stroke-red-300 '

const textClassName = 'font-normal text-[13px] leading-[30px] text-color-body'
export const ArrayList = (props: ArrayListProps) => {
  const {
    label,
    name,
    inputClassName,
    minusButtonClassName = 'text-minus-red',
    plusButtonClassName = 'text-gray-light ',
  } = props
  return (
    <FieldArray name={name}>
      {(fieldArrayProps) => {
        const { push, remove, form } = fieldArrayProps
        const { values } = form

        return (
          <>
            {values[name]?.map((node: string, index: number) => {
              return (
                <div className={'flex items-center gap-x-2  h-full'}>
                  <FormikInput
                    inputClassName={classNames(textClassName, inputClassName)}
                    key={index}
                    label={index > 0 ? `${label} ${index + 1} ` : label}
                    labelProps={{
                      variant: 'salesLabel',
                      required: true,
                    }}
                    onChange={(event) => console.log('event', event)}
                    name={`${name}[${index}]`}
                  />

                  {index === 0 ? (
                    <button
                      type="button"
                      className={classNames(
                        buttonClassName,

                        plusButtonClassName
                      )}
                      onClick={() => push('')}
                    >
                      <PlusCircleIcon />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className={classNames(
                        buttonClassName,
                        minusButtonClassName
                      )}
                      onClick={() => remove(index)}
                    >
                      <MinusCircleIcon />
                    </button>
                  )}
                </div>
              )
            })}
          </>
        )
      }}
    </FieldArray>
  )
}
